module.exports = __webpack_public_path__ + "images/site-plan-f9b96404035724586b49a766d0124cb3.svg";